import React from 'react';
import TagAndPillsContainer from '../../Componant/UiKits/TagAndPills';

const TagAndPills = () => {
  return (
    <div className='page-body'>
      <TagAndPillsContainer />
    </div>
  );
};

export default TagAndPills;
